import common from "./common.json";
import game from "./game.json";
import gameResults from "./gameResults.json";
import leaderboard from "./leaderboard.json";
import trivia from "./trivia.json";

export default {
  common,
  game,
  gameResults,
  leaderboard,
  trivia,
};
